import styled from 'styled-components'
import { respondTo } from '../../../../../styles/_respondTo'

export const ParagraphStyled = styled.p`
  color: #FFFFFF;
  font-size: 1.2rem;
  margin: 0px;
  text-align: center;

  ${respondTo.lg`
    font-size: 1.3rem;
  `}
`